import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { AccountTree as AccountTreeIcon, CloseRounded as CloseIcon, Hub as HubIcon } from '@mui/icons-material';
import { GRAPH_VIEWS } from 'components/knowledgeGraph/KnowledgeGraphContainer';
import { InfoTooltip } from 'components/v3';

const paperStyles = {
  display: 'flex',
  flexWrap: 'wrap'
};

const marginLeft = {
  marginLeft: '8px'
};

const iconFontSize = {
  fontSize: '24px'
};

const KnowledgeGraphHeaderOptions = ({
  useFlowGraph,
  toggleGraph,
  onClose,
  t,
  hideGraphToggle,
  hideCloseButton,
  graph
}) => {
  const handleToggleGraphType = (_, newValue) => {
    if (newValue) {
      const isFlow = newValue === GRAPH_VIEWS.FLOW;
      toggleGraph(isFlow);
    }
  };

  return (
    <>
      {!hideGraphToggle && (
        <Paper elevation={0} sx={paperStyles}>
          <ToggleButtonGroup
            value={useFlowGraph ? GRAPH_VIEWS.FLOW : GRAPH_VIEWS.VIS}
            exclusive
            onChange={handleToggleGraphType}
            size="medium"
            color="primary"
          >
            {graph.visualNodeLayoutFlow && (
              <ToggleButton value={GRAPH_VIEWS.FLOW}>
                <AccountTreeIcon sx={iconFontSize} />
              </ToggleButton>
            )}
            <ToggleButton value={GRAPH_VIEWS.VIS}>
              <HubIcon sx={iconFontSize} />
            </ToggleButton>
          </ToggleButtonGroup>
        </Paper>
      )}
      {!hideCloseButton && (
        <Paper elevation={0} sx={{ ...paperStyles, ...marginLeft }}>
          <InfoTooltip title={t('close')}>
            <ToggleButton value="close" onClick={onClose}>
              <CloseIcon sx={iconFontSize} />
            </ToggleButton>
          </InfoTooltip>
        </Paper>
      )}
    </>
  );
};

export default withTranslation('veezoo')(KnowledgeGraphHeaderOptions);
